import React, {createContext, useState, ReactNode} from 'react';
import type {IChartConfig} from '../types';

// Define the context shape
interface ChartContextType {
    chartConfig: IChartConfig | null;
    chartData: any | null;
    aggregatedChartData: any | null;
    showAnalysisPanel: boolean;
    hasNoData: boolean;
    setChartConfig: (config: IChartConfig) => void;
    setChartData: (data: any) => void;
    setAggregatedChartData: (data: any) => void;
    setShowAnalysisPanel: (show: boolean) => void;
    setHasNoData: (hasNoData: boolean) => void;
}

// Create the context with default values
export const ChartContext = createContext<ChartContextType>({
    chartConfig: null,
    chartData: null,
    aggregatedChartData: null,
    showAnalysisPanel: true,
    hasNoData: false,
    setChartConfig: () => {},
    setChartData: () => {},
    setAggregatedChartData: () => {},
    setShowAnalysisPanel: () => {},
    setHasNoData: () => {}
});

// Provider component
export const ChartContextProvider: React.FC<{
    children: ReactNode;
    showAnalysisPanel?: boolean;
}> = ({children, showAnalysisPanel: initialShowAnalysisPanel = true}) => {
    const [chartConfig, setChartConfig] = useState<IChartConfig | null>(null);
    const [chartData, setChartData] = useState<any | null>(null);
    const [aggregatedChartData, setAggregatedChartData] = useState<any | null>(null);
    const [showAnalysisPanel, setShowAnalysisPanel] = useState<boolean>(initialShowAnalysisPanel);
    const [hasNoData, setHasNoData] = useState<boolean>(false);

    return (
        <ChartContext.Provider
            value={{
                chartConfig,
                chartData,
                aggregatedChartData,
                showAnalysisPanel,
                hasNoData,
                setChartConfig,
                setChartData,
                setAggregatedChartData,
                setShowAnalysisPanel,
                setHasNoData
            }}
        >
            {children}
        </ChartContext.Provider>
    );
};

// Export the provider component as default to comply with fast refresh
export default ChartContextProvider;
